<script setup>
import SLAMetricCard from './SLAMetricCard.vue';
import { computed } from 'vue';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  noOfBreachesByEvent: {
    type: Object,
    default: () => {},
  },
  hitRate: {
    type: String,
    required: true,
  },
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { SLA_MISS_TYPES } = wootConstants;

const frtMisses = computed(
  () => props.noOfBreachesByEvent?.[SLA_MISS_TYPES.FRT] || 0
);

const nrtMisses = computed(
  () => props.noOfBreachesByEvent?.[SLA_MISS_TYPES.NRT] || 0
);
const rtMisses = computed(
  () => props.noOfBreachesByEvent?.[SLA_MISS_TYPES.RT] || 0
);
</script>

<template>
  <div
    class="flex sm:flex-row flex-col w-full gap-4 sm:gap-14 bg-white dark:bg-slate-900 rounded-xl border border-slate-75 dark:border-slate-700/50 px-6 py-4"
  >
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.HIT_RATE.LABEL')"
      :value="hitRate"
      :tool-tip="$t('SLA_REPORTS.METRICS.HIT_RATE.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div
      class="w-full sm:w-px h-full border border-slate-75 dark:border-slate-700/50"
    />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.LABEL')"
      :value="noOfConversations"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div
      class="w-full sm:w-px h-full border border-slate-75 dark:border-slate-700/50"
    />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.LABEL')"
      :value="noOfBreaches"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div
      class="w-full sm:w-px h-full border border-slate-75 dark:border-slate-700/50"
    />
    <SLAMetricCard
      class="uppercase"
      :label="SLA_MISS_TYPES.FRT"
      :value="frtMisses"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES_BY_TYPE.TOOLTIP.FRT')"
      :is-loading="isLoading"
    />
    <div
      class="w-full sm:w-px h-full border border-slate-75 dark:border-slate-700/50"
    />
    <SLAMetricCard
      class="uppercase"
      :label="SLA_MISS_TYPES.NRT"
      :value="nrtMisses"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES_BY_TYPE.TOOLTIP.NRT')"
      :is-loading="isLoading"
    />
    <div
      class="w-full sm:w-px h-full border border-slate-75 dark:border-slate-700/50"
    />
    <SLAMetricCard
      class="uppercase"
      :label="SLA_MISS_TYPES.RT"
      :value="rtMisses"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES_BY_TYPE.TOOLTIP.RT')"
      :is-loading="isLoading"
    />
  </div>
</template>
